import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-gray-200 dark:bg-neutral-600 w-full px-16 md:px-0 h-screen flex items-center justify-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-6xl md:text-7xl lg:text-9xl font-bold tracking-wider text-gray-300" }, "401", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-2xl md:text-3xl lg:text-5xl font-bold tracking-wider text-gray-500 mt-4" }, "Erro ao montar o chat ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-500 mt-4 pb-4 border-b-2 text-center" }, "Desculpe, a página que você está procurando não foi encontrada.", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Tente novamente ", -1)
const _hoisted_6 = [
  _hoisted_5
]


export default /*#__PURE__*/_defineComponent({
  __name: 'PageError',
  setup(__props) {


    function tryAgain () {
        document.location.reload()
    }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "bg-white border border-gray-200 flex flex-col items-center justify-center px-4 md:px-8 lg:px-24 py-8 rounded-lg shadow-2xl" }, [
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("span", {
        class: "flex cursor-pointer items-center space-x-2 bg-blue-600 hover:bg-blue-700 text-gray-100 px-4 py-2 mt-6 rounded transition duration-150",
        title: "Return Home",
        onClick: tryAgain
      }, _hoisted_6)
    ])
  ]))
}
}

})